import { v4 as uuidv4 } from "uuid";

function chillHop() {
  return [
    {
      name: "Kol Hayaty",
      cover: "https://www.matb3aa.com/wp-content/uploads/2018/08/amr.jpg",
      artist: "Amr Diab",
      audio: "https://media1.vocaroo.com/mp3/1jHyuo9z6xON",
      color: ["#8CD7DD", "#637F96"],
      id: uuidv4(),
      active: true,
    },
    {
      name: "Levitating",
      cover:
        "https://media1.popsugar-assets.com/files/thumbor/-PwZneMjcGAMmu36-hThF_0nEV8/0x826:4000x4826/fit-in/2048xorig/filters:format_auto-!!-:strip_icc-!!-/2020/10/02/639/n/1922564/ac561cde5f7737328a02d9.68078541_/i/dua-lipa-levitating-music-video-outfits.jpg",
      artist: "Dua Lipa",
      audio: "https://media1.vocaroo.com/mp3/1dFWMq66adMH",
      color: ["#627A9C", "#254470"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Russian Roulette",
      cover:
        "https://images.genius.com/879ef8ab5f99fb7a7331624bca8cd1d6.1000x1000x1.jpg",
      artist: "Rihanna",
      audio: "https://media1.vocaroo.com/mp3/1iOccyjQjzDt",
      color: ["#090909", "#000"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "My Future",
      cover:
        "https://thewildcattribune.com/wp-content/uploads/2020/08/50196819008_b1d1169c59_w.jpg",
      artist: "Billie Eilish",
      audio: "https://media1.vocaroo.com/mp3/1crkHYwKNZTb",
      color: ["#425DA3", "#26305D"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "wish you were gay",
      cover:
        "https://www.britishlgbtawards.com/wp-content/uploads/2019/01/MUSIC-BILLIE-EILISH.png",
      artist: "Billie Eilish",
      audio: "https://media1.vocaroo.com/mp3/1hSedVB6bxPE",
      color: ["#709C23", "#223B1E"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Xanny",
      cover:
        "https://i.pinimg.com/originals/e7/2c/a4/e72ca4b907dc61b49a8ddfe21de80e22.jpg",
      artist: "Billie Eilish",
      audio: "https://media1.vocaroo.com/mp3/1neV1xj132Q6",
      color: ["#709C23", "#223B1E"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Sweet but Psycho",
      cover:
        "https://images.genius.com/bcb30b444a55d3b3f4c9667cf3291198.1000x1000x1.jpg",
      artist: "Ava Max",
      audio: "https://media1.vocaroo.com/mp3/15xasb4XjS9w",
      color: ["#709C23", "#223B1E"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "UN DIA (ONE DAY)",
      cover:
        "https://mma.prnewswire.com/media/1219057/Universal_Music_Latin_Entertainment_Un_Dia.jpg?w=950",
      artist: "J Balvin",
      audio: "https://media1.vocaroo.com/mp3/1kZMMP3Azfcs",
      color: ["#728067", "#FFFFFF"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Midnight Sky",
      cover:
        "https://upload.wikimedia.org/wikipedia/en/5/5b/Miley_Cyrus_-_Midnight_Sky.png",
      artist: "Miley Cyrus",
      audio: "https://media1.vocaroo.com/mp3/1difVLMf4JWu",
      color: ["#CF6952", "#7E3F38"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Take You Dancing",
      cover:
        "https://upload.wikimedia.org/wikipedia/en/a/a3/TakeYouDancing.png",
      artist: "Jason Derulo",
      audio: "https://media1.vocaroo.com/mp3/146ehUNttJ7J",
      color: ["#215181", "#637F96"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Somebody Else",
      cover: "https://i1.sndcdn.com/artworks-000191583823-xz3l4t-t500x500.jpg",
      artist: "The 1975",
      audio: "https://media1.vocaroo.com/mp3/1iNZ7ZbWyxBm",
      color: ["#215181", "#637F96"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "calum scott",
      cover:
        "https://images.genius.com/73888ec51e31acb124913c5a89d3dd48.479x479x1.png",
      artist: "The reason your are here",
      audio: "https://media1.vocaroo.com/mp3/1fUTyYQabKad",
      color: ["#ea6824", "#ec9158"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Sway",
      cover:
        "https://images-na.ssl-images-amazon.com/images/I/71bCj3yaQwL._AC_UL600_SR600,600_.jpg",
      artist: "Michael Bublé",
      audio: "https://media1.vocaroo.com/mp3/1eWGJS9tRbXX",
      color: ["#6987A3", "#203A55"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Call of silence ",
      cover: "https://i1.sndcdn.com/artworks-000230799264-spzfbg-t500x500.jpg",
      artist: "Relaxing",
      audio: "https://media1.vocaroo.com/mp3/1fNIPcTtGffo",
      color: ["#215181", "#637F96"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Imagine dragons",
      cover:
        "https://i.pinimg.com/originals/0a/fa/62/0afa628528a62ebc8b594ff0c40bda68.jpg",
      artist: "Bad liar",
      audio: "https://media1.vocaroo.com/mp3/1gWy63Awl1cE",
      color: ["#CF6952", "#7E3F38"],
      id: uuidv4(),
      active: false,
    },
  ];
}

export default chillHop;
